<div class="current-station-type-editor" *ngIf="condition" [formGroup]="detailsFormGroup">

    <div class="row">
        <mat-form-field class="flex-grow">
            <mat-label>
                {{condition.type |
                translate:['tmc-yard.widgets.filter-administration.details-editor.transport.current-station-type-editor.current-station-type',
                translationService.language]}}
            </mat-label>
            <mat-select formControlName="stationType" name="stationType">

                <ng-container *ngFor="let type of stationTypes">
                    <mat-option [value]="type">
                        {{type | translate:["tmc-yard.common.enum.station-type."+type, translationService.language]}}
                    </mat-option>
                </ng-container>

            </mat-select>
        </mat-form-field>
    </div>
</div>